import "./PricingAndServices.module.css";
import Header from "@/reusable_sections/Header";
import MainServices from "./sections/MainServices";
import IntegrationCost from "./sections/IntegrationCost";
import TerminalFooter from "@/reusable_sections/Footer";
export default function PricingAndServicesPage() {
  return <div>
      <Header />
      <MainServices />
      <IntegrationCost />
      <TerminalFooter />
    </div>;
}